/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Map_SourceInputs */

const cs_import_map_source = /** @type {(inputs: Import_Map_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdrojový sloupec`)
};

const en_import_map_source = /** @type {(inputs: Import_Map_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source column`)
};

/**
* | output |
* | --- |
* | "Source column" |
*
* @param {Import_Map_SourceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_map_source = /** @type {((inputs?: Import_Map_SourceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Map_SourceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_map_source(inputs)
	return cs_import_map_source(inputs)
});